import { TextField } from '@mui/material';
import clsx from 'clsx';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { CustomTypography } from '../custom/CustomTypography';
import styles from './InputBlock.module.css';

interface InputFieldProps {
  name: string;
  label: string;
  subtitle?: string;
  required?: boolean;
  rows?: number;
}

export const InputField: FC<InputFieldProps> = ({
  name,
  label,
  required = false,
  subtitle,
  rows,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles.wrapper}>
      <CustomTypography
        className={clsx('text-14', required ? styles.asterisk : '', styles.inputLabel)}
      >
        {label}
      </CustomTypography>

      <TextField
        {...register(name)}
        className="custom"
        error={!!errors[name]}
        helperText={errors[name]?.message as string}
        fullWidth
        variant="standard"
        multiline={!!rows}
        rows={rows}
      />

      {subtitle && (
        <CustomTypography className={clsx('text-14', styles.inputDescription)} color="grey">
          {subtitle}
        </CustomTypography>
      )}
    </div>
  );
};
